import { styled } from '@mui/material';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';
import { ReactNode } from 'react';
import { HiCheckCircle, HiXCircle, HiOutlineExclamationCircle } from 'react-icons/hi2';

export const StyledNotistackComponent = styled(MaterialDesignContent)(({ theme }) => ({
  '&.notistack-MuiContent-primary': {
    border: `1px solid ${theme.palette.green[800]}`,
    backgroundColor: theme.palette.green[800],
    color: theme.palette.common.white,
    svg: {
      color: theme.palette.common.white,
    },
    '#notistack-snackbar': {
      gap: 6,
    },
  },
  '&.notistack-MuiContent-accent': {
    border: `1px solid ${theme.palette.green[500]}`,
    backgroundColor: theme.palette.green[500],
    color: theme.palette.common.white,
    '#notistack-snackbar': {
      svg: {
        color: theme.palette.common.white,
      },
      gap: 6,
    },
  },
  '&.notistack-MuiContent-neutral': {
    border: `1px solid ${theme.palette.neutral[500]}`,
    backgroundColor: theme.palette.neutral[500],
    color: theme.palette.common.white,
    '#notistack-snackbar': {
      svg: {
        color: theme.palette.common.white,
      },
      gap: 6,
    },
  },
  '&.notistack-MuiContent-destructive': {
    border: `1px solid ${theme.palette.red[500]}`,
    backgroundColor: theme.palette.red[500],
    color: theme.palette.common.white,
    '#notistack-snackbar': {
      svg: {
        color: theme.palette.common.white,
      },
      gap: 6,
    },
  },
}));

export const CustomSnackbarProvider: React.FC<{ children: ReactNode }> = ({ children }) => (
  <SnackbarProvider
    Components={{
      primary: StyledNotistackComponent,
      accent: StyledNotistackComponent,
      neutral: StyledNotistackComponent,
      destructive: StyledNotistackComponent,
    }}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    iconVariant={{
      primary: <HiCheckCircle fontSize={24} />,
      success: <HiCheckCircle fontSize={24} />,
      error: <HiXCircle fontSize={24} />,
      destructive: <HiOutlineExclamationCircle fontSize={24} />,
    }}
    classes={{
      containerAnchorOriginBottomLeft: 'md:!left-[350px]',
    }}
  >
    {children}
  </SnackbarProvider>
);
